import React, { useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { format } from 'date-fns';
import $ from 'jquery';
import * as R from "ramda";
import { DateWithModal } from '../../../_common/dateWithModal';




export const AuditTableFilter = ({ routerQuery, activityLogReducer }) => {
    const history = useHistory();
    const [date, setDate] = useState({startDate:new Date(routerQuery.fromDate), endDate:new Date(routerQuery.toDate) })
    const [userFilter, setUserFilter] = useState("");

    useEffect(() => {
        const filterForm = document.querySelector("#filterForm");
        const handleClick = (e) => {
            if (e.target.type === "button") {
                e.target.parentElement.classList.remove("show");
            }
        };

        filterForm.addEventListener("click", handleClick);
        return () => filterForm.removeEventListener("click", handleClick);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let users = R.sortWith([R.ascend(R.prop("sortableUserName"))])((routerQuery.operatorId ? activityLogReducer.items.filter(p => p.operatorId === routerQuery.operatorId) : activityLogReducer.items).reduce((acc, current) => {
        if (!acc.some(item => item.userName.toLowerCase() === current.userName.toLowerCase())) {
            current.sortableUserName = current.userName.toLowerCase();
            acc.push(current);
        }
        return acc;
    }, []))

    if(users.length > 0 && userFilter !== ""){
        users = users.filter(u => u.sortableUserName.indexOf(userFilter.toLowerCase()) > -1);
    }

    return (
        <nav className="navbar navbar-expand-sm navbar-light px-0 mb-xl-2 mt-sm mt-xl-0">
            <button className="btn-icon btn-alert bg-white navbar-toggler border-0 mx-auto rounded-max px-1" type="button" data-toggle="collapse" data-target="#navbarNavMenu" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                <span className="btn-alert-primary eva eva-menu-outline rounded-inherit my-auto lh-1 fs-sm p-2"></span>
                <span className="text-gray h6 lh-1 my-auto ml-2 mr-3">Menu</span>
            </button>
            <div className="collapse navbar-collapse flex-column" id="navbarNavMenu">
                <form className="form-inline container-default mx-auto justify-content-center" id="filterForm">
                    <DateWithModal selectedDate={date.startDate} setSelectedDate={((dateCalendar) => {
                        setDate({ ...date, startDate: dateCalendar })
                        const searchParams = new URLSearchParams(window.location.search);
                        searchParams.set("from", format(dateCalendar, 'yyyy-MM-dd'));
                        history.push(`/funecap/audit?${searchParams}`);
                    })} isRequired={true} classToolbar={true} />
                    <div className="d-inherit mx-2 text-gray">-</div>
                    <DateWithModal selectedDate={date.endDate} setSelectedDate={((dateCalendar) => {
                        setDate({ ...date, endDate: dateCalendar })
                        const searchParams = new URLSearchParams(window.location.search);
                        searchParams.set("to", format(dateCalendar, 'yyyy-MM-dd'));
                        history.push(`/funecap/audit?${searchParams}`);
                    })} 
                    isRequired={true} classToolbar={true} />
                    <div className="divider-vertical mx-3"></div>
					<div className={"my-1 input-group btn-dim rounded-max mr-2 btn-alert" + (!R.isNil(routerQuery.operatorId) ? " active" : " ")} role="button">
						<p className="form-control bg-none border-none rounded-inherit my-auto small" id="dropdownMenuButtonStatuts" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{R.isNil(routerQuery.operatorId) ? "Tous les Chargés" : activityLogReducer.items.find(p => p.operatorId === routerQuery.operatorId)?.operatorName || ""}</p>
						<div className="input-group-prepend rounded-inherit dropdown">
							<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4" id="dropdownMenuButtonStatuts" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<i className="eva eva-options-outline align-middle fs-root lh-0 o-70 o-100--hover"></i>
							</button>
							<div className="dropdown-menu dropdown-menu-right border-none shadow" aria-labelledby="dropdownMenuButtonStatuts">
                                <Link key={"charge_001"} type="button" className={"dropdown-item rounded-1" + (R.isNil(routerQuery.operatorId) ? " active" : "")} to={() => {
                                    const searchParams = new URLSearchParams(window.location.search);
                                    searchParams.delete("operatorId");
                                    return `/funecap/audit?${searchParams}`;
                                }}>
                                    Tous les dossiers
                                </Link>
								{
									activityLogReducer.items.reduce((acc, current) => {
                                        if (!acc.some(item => item.operatorName.toLowerCase() === current.operatorName.toLowerCase())) {
                                            acc.push(current);
                                        }
                                        return acc;
                                    }, []).map((item, index) => {
                                        const searchParams = new URLSearchParams(window.location.search);
                                        searchParams.set("operatorId", item.operatorId);
                                        return (
                                            <Link key={"charge_" + index} type="button" className={"dropdown-item rounded-1" + ((routerQuery.operatorId === item.operatorId.toString()) ? " active" : "")} to={`/funecap/audit?${searchParams}`}>
                                                    {item.operatorName.toUpperCase()}
                                                </Link>
                                        )
                                    }
                                )}

							</div>
						</div>
					</div>
					<div className={"my-1 input-group btn-dim rounded-max mr-2 btn-alert" + (!R.isNil(routerQuery.userId) ? " active" : " ")} role="button">
						<p className="form-control bg-none border-none rounded-inherit my-auto small" id="dropdownMenuButtonStatuts" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{R.isNil(routerQuery.userId) ? "Tous les Dossiers" : activityLogReducer.items.find(p => p.userId === routerQuery.userId)?.userName || ""}</p>
						<div className="input-group-prepend rounded-inherit dropdown">
							<button type="button" className="input-group-text btn btn-icon border-left-0 border-none rounded-inherit m-1 w-4" id="dropdownMenuButtonStatuts" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<i className="eva eva-options-outline align-middle fs-root lh-0 o-70 o-100--hover"></i>
							</button>
							<div className="dropdown-menu dropdown-menu-right border-none shadow " aria-labelledby="dropdownMenuButtonStatuts">
                                <div className={"dropdown-item my-1 input-group btn-dim ml-xl-auto w-100 w-md-auto"}>
                                    <input type="text" className="form-control bg-none border-none no-focus shadow-none" placeholder="Recherche" aria-label="Recherche" value={userFilter} onChange={(e) => setUserFilter(e.target.value)} />
                                    <div className="input-group-prepend rounded-inherit">
                                        <button type="button" className="input-group-text btn btn-icon border-left-0 border-none m-1 w-4"><i className="eva eva-search-outline align-middle fs-root lh-0 o-70 o-100--hover"></i></button>
                                    </div>
                                </div>

                                <Link key={-1} type="button" className={"dropdown-item rounded-1" + (R.isNil(routerQuery.userId) ? " active" : "")} to={() => {
                                    const searchParams = new URLSearchParams(window.location.search);
                                    searchParams.delete("userId");
                                    return `/funecap/audit?${searchParams}`;
                                }}>
                                    Tous les dossiers
                                </Link>
								{
									users.map((item, index) => {
                                        const searchParams = new URLSearchParams(window.location.search);
                                        searchParams.set("userId", item.userId);
                                        return (
                                                <Link key={index} type="button" className={"dropdown-item rounded-1" + ((routerQuery.userId === item.userId.toString()) ? " active" : "")} to={`/funecap/audit?${searchParams}`}>
                                                    {item.userName.toUpperCase()}
                                                </Link>
                                        )
                                    }
                                )}
							</div>
						</div>
					</div>
                </form>
            </div>
        </nav>
    );
};